import BybVrCard from "@Components/common/byb-ds/cards/byb-vr-card";
import { Box, Stack, alpha, styled } from "@mui/material";

export const HeroContent = styled(Stack)(({ theme }) => ({
  width: "100%",
  alignItems: "center",
  textAlign: "center",
  gap: theme.spacing(2),
  paddingTop: theme.spacing(22),
  paddingBottom: theme.spacing(2),
}));

export const ActivitySection = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(8),
  paddingBottom: theme.spacing(8),
}));

export const SectionHeaderButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  background: "transparent",
  border: 0,
  padding: 0,
  cursor: "pointer",
  color: theme.palette.common.white,
}));

export const ActivityRows = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1.5),
}));

export const SessionRowCard = styled(BybVrCard)(({ theme }) => ({
  padding: theme.spacing(2.25, 2.5),
  borderRadius: theme.spacing(2.5),
}));

export const SessionRowGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  width: "100%",
  gridTemplateColumns: "minmax(0, 2.4fr) minmax(9rem, 1.1fr) minmax(11rem, 1.4fr) minmax(7rem, 0.9fr)",
  alignItems: "center",
  columnGap: theme.spacing(3),
  rowGap: theme.spacing(1),
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "minmax(0, 1fr)",
  },
}));

export const SessionModeCell = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1.75),
  minWidth: 0,
}));

export const SessionModeIcon = styled("img")(({ theme }) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  borderRadius: "50%",
  objectFit: "cover",
  border: `1px solid ${alpha(theme.palette.common.white, 0.08)}`,
  flexShrink: 0,
}));

export const SessionsFooter = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  paddingTop: theme.spacing(2),
}));
